const KEYS = {
    DEVICE_ID: `:deviceId`,
    ORDER_ID: `:orderId`,
    UUID: `:uuid`,
    VIN: `:vin`,
    GROUP: `:group`,
    ID: `:id`,
    COUNTRY_CODE: `:countryCode`
};

module.exports = {
    KEYS,
    PREFIX: `/admin`,
    USER: {
        LOGIN: `/login`,
        IS_AUTHENTICATED: `/authenticated`,
        LOGOUT: `/logout`,
        CHANGE_CULTURE: `/customer/${KEYS.UUID}/culture`
    },
    TRIDION: {
        DASHBOARD_CONTENT: `/api/or/content/dashboard`,
        CONFIGURATION: `/api/content/configuration`
    },
    CUSTOMERS: {
        ROOT: `/customers`,
        MAIN: `/`,
        VEHICLES: `/admin/user/${KEYS.UUID}/vehicles?services=uio,connected,cp,cms`,
        DELETE: `/customer/${KEYS.UUID}`,
        ORDERS: `/customer/${KEYS.UUID}/orders`,
        ORDER_DETAILS: `/admin/order/${KEYS.ORDER_ID}`,
        PREFERRED_DEALER: `/customer/${KEYS.UUID}/userdata/preferredDealer`,
        SUBSCRIPTIONS: `/admin/subscriptions/device/${KEYS.DEVICE_ID}`,
        GROUPS: `/customer/${KEYS.UUID}/groups`
    },
    VEHICLE: {
        ROOT: `/vehicles`,
        VIN: `/:vin/customers`,
        ALL_SERVICES: `/admin/vehicle/vin/${KEYS.VIN}?services=uio,connected,cp,cms`,
        DEVICE: `/device/:id/customers`,
        DELETE_DEVICE: `/:vin/device`
    },
    GENERAL: {
        SHOW_INFO: `/api/show-info`,
        HEALTH: `/api/health`,
        VERSIONS: `/api/versions`,
        SHOW_VERSION_INFO: `/api/show-version-info`
    },
    SSO: {
        RESET_PASSWORD_EMAIL: `/sendResetPasswordEmail`,
        RESEND_ACTIVATION_MAIL: `/resendActivationMail`
    },
    LOCALE: {
        ROOT: `/countries`,
        LOCALE_BY_COUNTRY: `/:countryCode`,
        ALL_LANGUAGES: `/languages`
    },
    DEALER: {
        CAN_ACTIVATE_DEALER_ROLE: `/customer/${KEYS.UUID}/groups/canSetDealer`,
        CAN_DEACTIVATE_DEALER_ROLE: `/customer/${KEYS.UUID}/groups/canRemoveDealerRole`,
        ACTIVATE_DEACTIVATE_DEALER_ROLE: `/customer/${KEYS.UUID}/groups/${KEYS.GROUP}`
    }
};
